var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-06-07
 * @brief SEI 체크시트 Management 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { checkSheetState } from "../../../recoil/menuState";
import { reLoad, reloadSpg, userInfoLoginState } from "../../../recoil/userState";
//utils
import { alertState } from "../../../recoil/assessmentState";
import { langId } from "../../../recoil/langState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { useTrans } from "../../../utils/langs/useTrans";
function CheckSheetTree(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const setReloadSpg = useSetRecoilState(reloadSpg);
    const reload = useRecoilValue(reLoad);
    const langIds = useRecoilValue(langId);
    // props
    const { checksheetName, checkSheetItem, setCheckSheetItem, handleOpenPop, WorkModes } = props;
    const [layerOn, setLayerOn] = useState("");
    const [sheetNames, setSheetNames] = useState("");
    const [popInfo, setPopInfo] = useState(false);
    function Close(id) {
        setPopInfo(true);
        CUTIL.jsclose_Popup(id);
    }
    // checksheet Tree
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktype/tree`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds.toString() + reload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCheckSheetItem(data.body);
                if (!checksheet.spgName) {
                    setCheckSheet({
                        sheetType: userInfo.role == CONST.USERROLE_ADMIN ? checksheetName[0] : checksheetName[1],
                        spgName: userInfo.role == CONST.USERROLE_ADMIN
                            ? data.body[checksheetName[0]][0].name
                            : data.body[checksheetName[1]][0].spgName,
                    });
                }
            }
        }
    }, [data, langIds]);
    function onClickTree(sheet, item) {
        setReloadSpg(true);
        setCheckSheet({
            sheetType: sheet,
            spgName: sheet == checksheetName[1] ? item.spgName : item.name,
        });
        WorkModes("VIEW");
    }
    function ClickLayer(sheet) {
        setSheetNames(sheet);
        if (sheet !== layerOn) {
            setLayerOn(sheet);
        }
        else {
            setLayerOn("");
        }
    }
    // 레이어 아웃 포커싱이벤트
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isSelect = targetElement.classList.contains("btn-etc") || targetElement.closest(".btn-etc");
            if (isSelect) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".popup-etc");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    useEffect(() => {
        //등록
        handleOpenPop("pop-s-add", _jsx(CheckSpgPop, { sheetNames: sheetNames, checksheetName: checksheetName, popInfo: popInfo, setPopInfo: setPopInfo, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-s-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
    }, [sheetNames, popInfo]);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box treebar menutype" }, { children: [_jsx("div", Object.assign({ className: "box__header" }, { children: _jsx("p", Object.assign({ className: "list-info" }, { children: _jsx("span", Object.assign({ className: "ok" }, { children: t("라벨.체크시트미등록") })) })) })), userInfo.role == CONST.USERROLE_ADMIN ? ( // Role=> admin
                _jsx("div", Object.assign({ className: "manuarea" }, { children: checksheetName.map((sheetName, idx) => (_jsxs("ul", Object.assign({ className: "manulist" }, { children: [_jsxs("li", Object.assign({ className: "title-line" }, { children: [_jsx("p", { children: sheetName }), _jsx("button", Object.assign({ type: "button", className: "btn btn-etc", onClick: (e) => ClickLayer(sheetName) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uCD94\uAC00 \uB808\uC774\uC5B4\uD31D\uC5C5" })) })), _jsx("ul", Object.assign({ className: `popup-etc ${layerOn == sheetName ? "open" : ""}` }, { children: _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-g js-open", "data-pop": "pop-s-add", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.추가") }) })) }) }))] })), checkSheetItem &&
                                checkSheetItem[sheetName].map((item, idx) => (_jsx("li", Object.assign({ className: `${sheetName !== checksheetName[1] &&
                                        checksheet.sheetType + "_" + checksheet.spgName == sheetName + "_" + item.name
                                        ? "on"
                                        : sheetName == checksheetName[1] &&
                                            checksheet.sheetType + "_" + checksheet.spgName == sheetName + "_" + item.spgName
                                            ? "on"
                                            : ""}`, onClick: (e) => onClickTree(sheetName, item) }, { children: _jsx("a", Object.assign({ href: "#", className: `${!item.isActive ? "ok" : ""}`, onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: sheetName == checksheetName[1] ? item.spgName : item.name }) })) }), "spgs_" + idx.toString())))] }), "sheetTree_" + idx.toString()))) }))) : (
                // Role => SupperUser
                _jsx("div", Object.assign({ className: "manuarea" }, { children: checksheetName
                        .filter((_, idx) => idx == 1)
                        .map((sheetName, idx) => (_jsxs("ul", Object.assign({ className: "manulist" }, { children: [_jsxs("li", Object.assign({ className: "title-line" }, { children: [_jsx("p", { children: sheetName }), _jsx("button", Object.assign({ type: "button", className: "btn btn-etc", onClick: (e) => ClickLayer(sheetName) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uCD94\uAC00 \uB808\uC774\uC5B4\uD31D\uC5C5" })) })), _jsx("ul", Object.assign({ className: `popup-etc ${layerOn == sheetName ? "open" : ""}` }, { children: _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-g js-open", "data-pop": "pop-s-add", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.추가") }) })) }) }))] })), checkSheetItem &&
                                checkSheetItem[sheetName].map((item, idx) => (_jsx("li", Object.assign({ className: `${sheetName !== checksheetName[1] &&
                                        checksheet.sheetType + "_" + checksheet.spgName == sheetName + "_" + item.name
                                        ? "on"
                                        : sheetName == checksheetName[1] &&
                                            checksheet.sheetType + "_" + checksheet.spgName == sheetName + "_" + item.spgName
                                            ? "on"
                                            : ""}`, onClick: (e) => onClickTree(sheetName, item) }, { children: _jsx("a", Object.assign({ href: "#", className: `${!item.isActive ? "ok" : ""}`, onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: sheetName == checksheetName[1] ? item.spgName : item.name }) })) }), "spgs_" + idx.toString())))] }), "sheetTree_" + idx.toString()))) })))] })) }));
}
export default CheckSheetTree;
function CheckSpgPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { checksheetName, sheetNames, popInfo, setPopInfo } = props;
    // useState
    const [errorList, setErrorList] = useState([]);
    const [spgItem, setSpgItem] = useState([]);
    const [spgSelItem, setSpgSelItem] = useState([]);
    const [spg, setSpg] = useState(null);
    const [spgSel, setSpgSel] = useState(null);
    const [checkSubtypeName, setCheckSubtypeName] = useState("");
    const [checkSubtypeNameSel, setCheckSubtypeNameSel] = useState("");
    const [subMemo, setSubMemo] = useState("");
    const [subType, setSubType] = useState(false);
    const [companyItem, setCompanyItem] = useState([]);
    const [company, setCompany] = useState(null);
    const [companySel, setCompanySel] = useState(null);
    const [checkType, setCheckType] = useState("");
    const [checkTypeItem, setChecktypeItem] = useState([]);
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [versionInfo, setVersionInfo] = useState(null);
    const [description, setDescription] = useState("");
    const [checkTyped, setCheckTyped] = useState(true);
    const [checkSubed, setCheckSubed] = useState(true);
    const [checkVseioned, setCheckVersioned] = useState(true);
    //고객향 점검 company
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktype/companies`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCompanyItem(data.body);
                if (companySel) {
                    setCompanySel(companySel);
                }
                setCompanySel(data.body[0]);
                if (popInfo) {
                    setErrorList([]);
                    setSpg(null);
                    setSpgItem([]);
                    setCheckSubtypeName("");
                    setCheckSubtypeNameSel("");
                    setSubMemo("");
                    setSubType(false);
                    setCompany(null);
                    setCheckType("");
                    setVersionInfo(null);
                    setDescription("");
                    setPopInfo(false);
                    setCompanySel(null);
                    setSpgSel(null);
                }
            }
        }
    }, [data, popInfo]);
    /*
    // 진단 유형 선택
    function SheetClick(sheet) {
      if (popSheetName !== sheet) {
        setPopSheetName(sheet);
        setSpgType(true);
        setSpgItem([])
      }
    }
    */
    // 회사 유형 선택
    function CompanyClick(item, companyType) {
        if (companyType == 1) {
            setErrorList(errorList.filter((err) => err.field !== "companyId"));
            setCompany(item);
        }
        else if (companyType == 2) {
            setErrorList(errorList.filter((err) => err.field !== "companySelId"));
            setCompanySel(item);
        }
        setSpgSel(null);
        setCheckSubtypeNameSel("");
        setCheckType("");
        setVersionInfo(null);
        setDescription("");
        setCheckTyped(false);
        setCheckSubed(false);
        setCheckVersioned(false);
    }
    // 점검 유형에 대한 select
    function SpgSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (sheetNames == checksheetName[0]) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = [];
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/product/spgs`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setSpgItem(data.body);
                    }
                }
            }
            else {
                if (company) {
                    CUTIL.onClickSelect(e, CUTIL.selectOption);
                    let data = null;
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "GET",
                        appPath: `/product/company/${company.companyId}/spgs`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setSpgItem(data.body);
                        }
                        else {
                            // alert(data.errorList.map((err) => (err.msg)));
                        }
                    }
                }
            }
        });
    }
    // spg 선택
    function SpgClick(item) {
        setErrorList(errorList.filter((err) => err.field !== "spgName"));
        setSpg(item);
    }
    // 불러오기 점검유형에 대한 select
    function SpgSubSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${companySel.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgSelItem(data.body);
                }
                else {
                    // alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    // 불러오기 설비유형 선택
    function SpgSleClick(item) {
        setErrorList(errorList.filter((err) => err.field !== "spgSel"));
        setSpgSel(item);
        setCheckSubtypeNameSel("");
        setCheckType("");
        setVersionInfo(null);
        setDescription("");
        setCheckTyped(false);
        setCheckSubed(false);
        setCheckVersioned(false);
    }
    // 상세 유형 명 input
    function SubTypeChange(e) {
        setErrorList(errorList.filter((err) => err.field !== "checkSubtypeName"));
        setCheckSubtypeName(e.target.value);
    }
    // 불러오기 on||off
    function CheckSubType(e) {
        if (!subType) {
            setSubType(true);
        }
        else {
            setErrorList([]);
            setSpg(null);
            setCheckSubtypeNameSel("");
            setSubType(false);
            setCompany(null);
            setCheckType("");
            setVersionInfo(null);
            setDescription("");
            setSubType(false);
        }
        setErrorList([]);
    }
    // 불러오기 점검 유형 목록 가져오기
    function CheckTypes(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktypes?companySpgId=${spgSel.companySpgId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setChecktypeItem(data.body);
                    setCheckTyped(true);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 불러오기 상세 유형 목록
    function CheckTypeSub(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setCheckSubed(true);
            setErrorList(errorList.filter((err) => err.field !== "checkType"));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheckSubtypeItem(data.body);
                    setCheckType(type);
                    setCheckSubtypeNameSel("");
                    setVersionInfo(null);
                    setDescription("");
                    setCheckSubed(false);
                    setCheckVersioned(false);
                    setCheckSubed(true);
                    setCheckVersioned(true);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 버젼
    function CheckTypeVersion(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkSubtypeNameSel"));
            let data = null;
            // 상세 유형 초기화
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheckVersiontypeItem(data.body);
                    setCheckSubtypeNameSel(type.checkSubName);
                    setDescription(type.description ? type.description : "");
                    setCheckVersioned(false);
                    setVersionInfo(null);
                    setCheckVersioned(true);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 불러오기 버젼 선택
    function CheckTypeVersionSel(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkVersionId"));
            setVersionInfo(type);
        });
    }
    // 등록
    function CheckSheetSaveed(e) {
        if (!subType) {
            if (!spg || !checkSubtypeName || (sheetNames == checkSubtypeName[1] && !company)) {
                setErrorList([
                    !checkSubtypeName && {
                        field: "checkSubtypeName",
                        msg: t("라벨.필수항목을입력하지않으셨습니다"),
                    },
                    !spg && { field: "spgName", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !company && { field: "companyId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                ]);
            }
            else {
                CheckSheetSave(sheetNames);
            }
        }
        else {
            if (!spgSel || !checkSubtypeName || !companySel || !checkType || !checkSubtypeNameSel || !versionInfo) {
                setErrorList([
                    !spgSel && { field: "spgSel", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !checkSubtypeName && {
                        field: "checkSubtypeName",
                        msg: t("라벨.필수항목을입력하지않으셨습니다"),
                    },
                    !company && { field: "companySelId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !checkType && { field: "checkType", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !checkSubtypeNameSel && {
                        field: "checkSubtypeNameSel",
                        msg: t("라벨.필수항목을입력하지않으셨습니다"),
                    },
                    !versionInfo && { field: "checkVersionId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                ]);
            }
            else {
                CheckSheetSave(sheetNames);
            }
        }
    }
    //  등록
    function CheckSheetSave(sheetType) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/checksheet/checktype/checksubtype/checkversion/copy`,
                appQuery: {
                    versionIdCopiedFrom: !subType ? null : versionInfo && versionInfo.checkVersionId,
                    companyId: sheetType == checksheetName[0] ? null : company.id,
                    spgName: spg ? spg.spgName : "",
                    checktypeName: sheetNames,
                    checkSubtypeName: checkSubtypeName,
                    description: subMemo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    Close("pop-s-add");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-add", type: CONST.TYPE_INNRE, divTag: t("라벨.등록완료") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function Close(id) {
        setSubType(false);
        setPopInfo(true);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("ul", Object.assign({ className: "locate" }, { children: _jsx("li", { children: sheetNames }) })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [sheetNames == checksheetName[1] && (_jsx("ul", Object.assign({ className: "form__input brd-bottom-1 pb-16 mb-16" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.회사명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select company ${errorList.filter((err) => err.field === "companyId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popInfo ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CompanyClick(item, 1) }, { children: item.companyName }), "company_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "companyId").map((err) => err.msg) }))] }))] }) }))), _jsxs("div", Object.assign({ className: "tbl__top brd-bottom-1 pb-16 mb-16" }, { children: [_jsx("h2", { children: t("라벨.점검유형") }), _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsxs("div", Object.assign({ className: "input__area flex-1" }, { children: [_jsxs("div", Object.assign({ className: `select checkType w110 ` }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: sheetNames })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checksheetName.map((sheetName, idx) => (_jsx("li", Object.assign({ className: "option" }, { children: sheetName }), "popSheet_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: `select spgType w220 ${errorList.filter((err) => err.field === "spgName").length > 0 ? " input-error" : ""}`, onClick: (e) => SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: spgItem.length <= 0 ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgItem &&
                                                                    spgItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => SpgClick(item) }, { children: item.spgName }), "popSpg_" + idx.toString()))) })] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray" }, { children: _jsx("span", { children: t("라벨.신규SPG") }) }))] }))] })), _jsxs("ul", Object.assign({ className: "form__input h424" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세유형명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "inp22", placeholder: t("라벨.텍스트입력"), className: `${errorList.filter((err) => err.field === "checkSubtypeName").length > 0 ? " input-error" : ""}`, value: checkSubtypeName, onChange: (e) => SubTypeChange(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkSubtypeName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "inp23", placeholder: t("라벨.텍스트입력"), value: subMemo, onChange: (e) => setSubMemo(e.target.value) }), _jsxs("div", Object.assign({ className: "flex-inline left-right mt-8" }, { children: [_jsxs("p", Object.assign({ className: "txt-info ml-0" }, { children: ["*", !subType ? t("라벨.저장된체크시트유형내용을복사해올까요") : t("라벨.불러올체크시트를선택")] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic pw-12 bg-no", onClick: (e) => CheckSubType(e) }, { children: _jsx("span", { children: !subType ? `${t("라벨.불러오기")}(${t("라벨.선택")})` : t("라벨.취소") }) }))] }))] }))] }), subType && (_jsxs("li", Object.assign({ className: "mt-32 pb-30" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBD88\uB7EC\uC62C \uCCB4\uD06C\uC2DC\uD2B8 \uC720\uD615" })) })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.회사명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select company ${errorList.filter((err) => err.field === "companySelId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: subType ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CompanyClick(item, 2) }, { children: item.companyName }), "company_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "companyId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select spg  ${errorList.filter((err) => err.field === "spgSel").length > 0 ? " input-error" : ""}`, onClick: (e) => companySel && SpgSubSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: spgItem.length <= 0 ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgSelItem &&
                                                                                        spgSelItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => SpgSleClick(item) }, { children: item.spgName }), "popSpg_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgSel").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select check  ${errorList.filter((err) => err.field === "checkType").length > 0 ? " input-error" : ""}`, onClick: (e) => spgSel && CheckTypes(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !checkTyped ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkTypeItem &&
                                                                                        checkTypeItem
                                                                                            .filter((non) => non.checkTypeId != 4)
                                                                                            .map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeSub(type) }, { children: type.description }), "type_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkType").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select checkSub ${errorList.filter((err) => err.field === "checkSubtypeNameSel").length > 0
                                                                                ? " input-error"
                                                                                : ""}`, onClick: (e) => checkType && CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !checkSubed ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                                                        checkSubTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(type) }, { children: type.checkSubName }), "subtype_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkSubtypeNameSel").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.버전") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select version ${errorList.filter((err) => err.field === "checkVersionId").length > 0 ? " input-error" : ""}`, onClick: (e) => checkSubtypeNameSel && CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !checkVseioned ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                                                        checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "version_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkVersionId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit mt-0" }, { children: [t("라벨.메모"), " "] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("p", Object.assign({ className: "text" }, { children: description && description })) }))] })] })) }))] })))] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-s-add") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => CheckSheetSaveed(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))] }));
}
